// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const UPDATE_ACCOUNT_INFO = "updateUserAccountInfo";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";

const state = {
  user_personal_info: {
    name: "",
    meli: "",
    area: "",
    role: "",
    chart: "",
    email: ""
  },
  access_token: ""
};

const getters = {
  currentUserPersonalInfo(state) {
    return state.user_personal_info;
  }
};

const actions = {
  [UPDATE_PERSONAL_INFO](context, payload) {
    context.commit(SET_PERSONAL_INFO, payload);
  }
};

const mutations = {
  [SET_PERSONAL_INFO](state, user_personal_info) {
    state.user_personal_info = user_personal_info;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
